<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name color-71aa3f" style="float:none">
                        <span> Over Due Customers</span>
                        <template v-if="rowCheckShow && rows.length > 0">
                            <label for="tierNotification" :style="'text-align: center;font-size: 23px;margin-bottom: 0;margin-left:60px;' + tierNotificationColor">
                                <strong>{{ tierNotification }}</strong>
                            </label>
                        </template>
                    </div>
                    <!-- <button id="create"   v-on:click.prevent="addCustomer">+Add</button> -->
                    <!-- <div class="btn-group pull-right">
                        <button type="button" class="btn_all_dunning btn general-button btn-primary" v-on:click="allClickDunning()">All </button>
                        <button type="button" class="btn_my_dunning btn general-button btn-secondary" v-on:click="myClickDunning()">My Self</button>
                    </div> -->
                    <div class="clearfix"></div>
                    <div class="forms-container mt-3">
                        <div class="row no-margin">
                            <!-- <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                <label for="totalDue">Search For Collector</label> -->
                                <!-- <select class="form-control show-tick" id="collectorFilter">
                                <option value="">Please select</option>
                                <template v-for="(collectorData , index) in collectorArr">
                                <option :value="collectorData.value">{{collectorData.text}}</option>
                                </template>
                                </select>-->
                                <!-- <v-select
                                    name="collectorIdSearch"
                                    v-model="collectorIdSearch"
                                    @change="changedValue"
                                    id="collectorIdSearch" label="text"
                                    :options="collectorArr"
                                    :required="true"
                                    v-validate="'required'"
                                    ></v-select>
                            </div> -->
                            <!-- <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                                <label for="totalDue">Search For Entity </label>
                                <v-select
                                    label="text"
                                    name="entityIdSearch"
                                    v-model="entityIdSearch"
                                    id="entityIdSearch"
                                    :options="entityArr"
                                    :required="true"
                                    :searchable="false"
                                    v-validate="'required'">
                                </v-select>
                            </div> -->
                            <div class="col-lg-4 col-md-6 col-xs-12 col-sm-12">
                                <label for="totalDue"><strong>Search For Entity :</strong></label>
                                <v-select
                                    label="text"
                                    name="entityIdSearch"
                                    v-model="entityIdSearch"
                                    id="entityIdSearch"
                                    :options="entityArr"
                                    :required="true"
                                    :searchable="false"
                                    :clearable="false"
                                    v-validate="'required'">
                                </v-select>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <label for="customer_id"><strong>Search For Customer :</strong></label>
                                <v-select class="multi-select-list" v-model="customer_id"
                                            name="customer_id"
                                            id="customer_id"
                                            label="text"
                                            :filterable="false"
                                            :clearable="false"
                                            :options="customerArr"
                                            :searchable="true"
                                            @search="onSearchCustomerName" 
                                            placeholder="Search Customer">
                                        </v-select>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <label for="status_id"><strong>Overdue Notice Status :</strong></label>
                                <v-select class="multi-select-list" v-model="status_id"
                                            name="status_id"
                                            id="status_id"
                                            label="text"
                                            :filterable="false"
                                            :clearable="false"
                                            :options="statusArr"
                                            :searchable="true"
                                            placeholder="Select Status">
                                        </v-select>
                            </div>
                            <!-- <template v-if="entityIdSearch.value != 0 && rows.length > 0"> -->
                            <div class="col-md-6 mt-30">
                                <input id="addTaskBtn" type="button" value="Filter" class="btn general-button btn-success" v-on:click="onColumnFilter()">
                                <input id="addTaskBtn" type="button" value="Reset" class="btn general-button btn-success" v-on:click="reset()">
                            </div>
                            <template v-if="rowCheckShow && rows.length > 0">
                                <div class="col-md-6 mt-30">
                                    <template v-if="permission.name == 'can_sends_dunning_notice_mails'" v-for="(permission, index) in permissions">
                                        <button :disabled="!isShowQueueEmailButton" :key="'Queue_Up_' + index" title='Send mail to all' v-on:click="scheduleDunningNotices($event, false)" class="btn general-button btn-success ml-1" :style="queueButtonColor">Queue Emails</button>
                                    </template>
                                </div>
                            </template>
                            <!-- <div class="col-lg-4 col-md-4 col-xs-12 col-sm-12 ">
                                <label for="totalDue">Search For Past Due</label>
                                <select class="form-control show-tick" id="totlaDueCondition">
                                    <option value="">Please select</option>
                                    <option value="=">is</option>
                                    <option value=">">></option>
                                    <option value=">=">>=</option>
                                    <option value="<"><</option>
                                    <option value="<="><=</option>
                                    <option value="between">Between</option>
                                </select>
                            </div>
                            <div class="col-lg-4 col-md-4 col-xs-12 col-sm-12" v-show="totalDueCondition != ''">
                                <label for="totalDue">Enter Value</label>
                                <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt1"/>
                            </div>
                            <div class="col-lg-4 col-md-4 col-xs-12 col-sm-12" v-show="totalDueCondition == 'between'">
                                <label for="totalDue">Enter Value</label>
                                <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt2"/>
                            </div>
                             -->
                            
                        </div>
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="pb-20">
                        <button class="btn general-button btn-success" @click="$refs.listDunningNotice.expandAll()">Expand All</button>
                        <button class="btn general-button btn-success" @click="$refs.listDunningNotice.collapseAll()">Collapse All</button>
                        <!-- {{permissions}} -->
                        <!-- <template v-if="permission.name == 'can_sends_dunning_notice_mails'" v-for="(permission, index) in permissions">
                            <button :key="'Queue_Up_' + index" title='Send mail to all' v-on:click="scheduleDunningNotices($event)" class="btn general-button btn-success ml-1">Queue Up</button>
                        </template> -->
                    </div>
                    <div class="app-support-ticket-good-table-container">
                        <vue-good-table class="dunningNoticeList"
                            @on-select-all="selectAllCallback($event)"
                            ref="listDunningNotice"
                            mode="remote"
                            title="Over Due"
                            @on-page-change="onPageChange"
                            @on-selected-rows-change="selectionChanged"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            :totalRows="totalRecords"
                            :columns="columns"
                            :rows="rows"
                            :pagination-options="{
                                enabled: true,
                                mode: 'pages',
                                pageLabel: 'Page',
                                position: 'bottom',
                                perPage: serverParams.perPage,
                                setCurrentPage: serverParams.setCurrentPage,
                                perPageDropdown: customPerPageArr,
                                dropdownAllowAll: false,
                            }"
                            :select-options="{
                                enabled: rowCheckShow,
                                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                selectionInfoClass: 'custom-class',
                                selectionText: 'rows selected',
                                clearSelectionText: 'clear',
                                disableSelectInfo: false, // disable the select info panel on top
                                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                            }"
                            :search-options="{
                                enabled: false,
                            }"
                            :group-options="{
                                enabled: true,
                                collapsable: true,
                            }">
                            <template slot="table-header-row" slot-scope="props">
                                <template v-if="rowCheckShow">
                                    <span v-if="props.column.field == 'origindes'">
                                        <input style="margin-left: 10px;" checked type="checkbox" @click.stop="customerWiseSelected(props.row, 'select-all', false, $event)" value="Select All" class="pointer-events">
                                        <!-- <input type="button" v-on:click.stop="customerWiseSelected(props.row, 'de-select-all')" value="Deselect All"> -->
                                    </span>
                                    <span v-else-if="props.column.field == 'invoiceid'">
                                        {{ props.row['label'] }}
                                    </span>
                                </template>
                                <template v-else>
                                    <span v-if="props.column.field == 'origindes'">
                                        {{ props.row['label'] }}
                                    </span>
                                </template>
                                <template v-if="rowCheckShow">
                                    <span v-if="props.column.field == 'actions' && status_value == 'active'">
                                        <button type="button" title="Inactive dunning notices" @click="inactiveDunningNotice(props.row, $event)" class="btn general-button btn-success" style="font-size: 12px;">Mark Inactive</button>
                                    </span>
                                    <span v-else-if="props.column.field == 'actions' && status_value == 'inactive'">
                                        <button type="button" title="Inactive dunning notices" @click="inactiveDunningNotice(props.row, $event)" class="btn general-button btn-success" style="font-size: 12px;">Mark Active</button>
                                    </span>
                                    <span v-else-if="props.column.field == 'actions' && status_value == 'all'">
                                        <button type="button" v-if="props.row.children[0].overdue_status == 'active'" title="Inactive dunning notices" @click="inactiveDunningNotice(props.row, $event)" class="btn general-button btn-success" style="font-size: 12px;">Mark Inactive</button>
                                        <button type="button" v-else-if="props.row.children[0].overdue_status == 'inactive'" title="Inactive dunning notices" @click="inactiveDunningNotice(props.row, $event)" class="btn general-button btn-success" style="font-size: 12px;">Mark Active</button>
                                    </span>
                                </template>
                                <template v-else>
                                    <span v-if="props.column.field == 'actions'">
                                        {{ props.row['label'] }}
                                    </span>
                                </template>
                            </template>
                            
                            <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParams.perPage"
                                                      @change="changedValue"
                                                      @input="changedValueCustomPerPage()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="customPerPageArr"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRows}} of {{totalRecords}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClick(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberList() < displayPage">
                                                    <template v-for="(n, index) in pageNumberList()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParams.page) <= pageCompare">
                                                        <template v-for="(n, index) in displayPage">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParams.page) >= (pageNumberList() - (pageCompare-1))">
                                                        <template v-for="(n, index) in pageNumberList()">
                                                            <template v-if="n > (pageNumberList() - displayPage)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberList()" v-if="(n >= (Number(serverParams.page) - (pageCompare -1))) && (n <= (Number(serverParams.page) + (pageCompare -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClick(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(pageNumberList())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>                                
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input v-model="jumpToPage" type="text" class="form-control form-control-sm" name="jumpToPage" id="jumpToPage" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div slot="selected-row-actions" slot-scope="computed">
                                {{computed.selectedRows}}
                                <!-- <template v-if="permission.name == 'can_sends_dunning_notice_mails'" v-for="(permission, index) in permissions"> -->
                                    <!-- <button v-on:click.prevent="sendMailALL" class="btn general-button btn-success waves-effect" data-target="#queueEmail">ALL</button> -->
                                    <!-- <button title='Send mail to all' v-on:click="scheduleDunningNotices($event)" class="btn general-button btn-success">Queue Up</button> -->
                                    <!-- <button data-toggle="modal" title='Send mail to all' class="btn general-button btn-success" data-target="#queueEmailAll" >Send Mail To All {{totalRecords}}</button> -->
                                    <!-- <button data-toggle="modal" title='Send mail to selected' class="btn general-button btn-success" data-target="#queueEmail" >Queue Emails To Selected</button> -->
                                                           <!-- <button v-on:click="sendMail($event)">Send Mail</button> -->
                                <!-- </template>     -->
                                <template v-if="entityIdSearch.value != 0">
                                    <template v-if="permission.name == 'can_sends_dunning_notice_mails'" v-for="(permission, index) in permissions">
                                        <button :key="'Queue_Up_All_' + index" title='Send mail to all' v-on:click="scheduleDunningNotices($event, false)" class="btn general-button btn-success ml-1">Queue Emails To All</button>
                                        <button :key="'Queue_Up_' + index" title='Send mail to selected' v-on:click="scheduleDunningNotices($event, true)" class="btn general-button btn-success ml-1">Queue Emails To Selected</button>
                                    </template>
                                </template>
                            </div>
                        </vue-good-table>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="queueEmailAll" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Send Over Due To All</h4>
                        </div>
                        <form class="form-inline" id="importTasksform" enctype="multipart/form-data">
                            <div class="modal-body">
                                <!--<div class="body col-xs-12 col-sm-6">-->
                                <!--<label for="collector">Select Email Template</label>-->
                                <!--<div class="clearfix">-->
                                <!--<div>-->
                                <!--<v-select-->
                                <!--name="collectorId"-->
                                <!--v-model="collectorId"-->
                                <!--@change="changedValue"-->
                                <!--id="collectorId" label="text"-->
                                <!--:options="collectorArr"-->
                                <!--:required="true"-->
                                <!--v-validate="'required'"-->
                                <!--&gt;</v-select>-->
                                <!--<span v-show="errors.has('collectorId')" class="help is-danger" v-if="errors.has('collectorId')"><font color="red">Please Select Emial Template</font></span>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="demo-switch">-->
                                <!--<div class="switch">-->
                                <!--<label>Schedule <input type="checkbox" value="checked" v-model="checked"><span class="lever"></span></label>-->
                                <!--</div>-->
                                <!--</div>-->
                                <div class="clearfix">
                                    <label>Select Email Template</label>
                                    <div class="row justify-content-md-center mb-2">
                                        <select class="col-md-6" id="duningTemplateAll" name="duningTemplateAll">
                                            <option value="dunningNotice" select="selected">Default</option>
                                            <!--<option value="dunning">Template 1</option>-->
                                        </select>
                                    </div>
                                </div>
                                <!--<input type="text" id="scheduleDateAll" name="schedule_date"-->
                                <!--class="datetimepicker form-control"-->
                                <!--placeholder="Please choose date & time..." :disabled="!checked">-->
                                <!--</div>-->
                                <div class="modal-footer">
                                    <button type="button" id='btnsendmailall' v-on:click="sendMailALL($event)" class="btn general-button btn-success waves-effect">Send to All</button>
                                    <button type="button" class="btn general-button btn-danger waves-effect" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="queueEmail" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Send Over Due To Selected</h4>
                        </div>
                        <form class="form-inline" id="importTasksform" enctype="multipart/form-data">
                            <div class="modal-body">
                                <!--<div class="body col-xs-12 col-sm-6">-->
                                <!--<label for="collector">Select Email Template</label>-->
                                <!--<div class="clearfix">-->
                                <!--<div>-->
                                <!--<v-select-->
                                <!--name="collectorId"-->
                                <!--v-model="collectorId"-->
                                <!--@change="changedValue"-->
                                <!--id="collectorId" label="text"-->
                                <!--:options="collectorArr"-->
                                <!--:required="true"-->
                                <!--v-validate="'required'"-->
                                <!--&gt;</v-select>-->
                                <!--<span v-show="errors.has('collectorId')" class="help is-danger" v-if="errors.has('collectorId')"><font color="red">Please Select Emial Template</font></span>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="demo-switch">-->
                                <!--<div class="switch">-->
                                <!--<label>Schedule <input type="checkbox" value="checked" v-model="checked"><span class="lever"></span></label>-->
                                <!--</div>-->
                                <!--</div>-->
                                <div class="clearfix">
                                    <label>Select Email Template</label>
                                    <div class="row justify-content-md-center mb-2">
                                        <select class="col-md-6" id="duningTemplateSelected" name="duningTemplateSelected" v-model="duningTemplateSelected">
                                            <option value="dunningNotice" select="selected">Default</option>
                                            <!--<option value="dunning">Template 1</option>-->
                                        </select>
                                    </div>
                                </div>
                                <!--<input type="text" id="scheduleDate" name="schedule_date"-->
                                <!--class="datetimepicker form-control"-->
                                <!--placeholder="Please choose date & time..." :disabled="!checked">-->
                                <div class="modal-footer">
                                    <button type="button" id='btnsendmail' v-on:click="sendMail($event)" class="btn general-button btn-success waves-effect">Send to Selected</button>
                                    <button type="button" class="btn general-button btn-danger waves-effect" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>

    import Vue from 'vue';
    import SessioMixin from '../../mixins/sessionmixin';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import FrontFooter from '@/components/partials/FrontFooter';
    Vue.use(VueGoodTable);
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');

    export default {
        name: "listDunningNotice",
        mixins: [SessioMixin],
        components: {
            'app-footer': FrontFooter,
        },
        data: () => ({
                selectAllInvoice: 1,
                rowCheckShow: false,
                displayPage: 7,
                pageCompare: 0,
                paginationDisplayRows: '',
                jumpToPage: 0,
                customPerPageArr: ['10', '25', '50', '100', '200', '500'],

                permissions: [],
                cantAccessPage: true,
                checked: false,
                flagAll: '',
                isLoggedIn: false,
                message: 'all',
                firstLoad: 0,
                totalDueCondition: '',
                searchFieldName: '',
                duningTemplateSelected: 'dunningNotice',
                duningTemplateAll: 'dunningNotice',
                tierNotification: '',
                tierNotificationColor: '',
                isShowQueueEmailButton: true,
                queueButtonColor: '',
                columns: [
                    /*
                    {
                        label: 'Collector',
                        field: 'user_first_name',
                        sortable: false,
                        filterable: false,
                    },*/
                    {
                        label: 'Origin',
                        field: 'origindes',
                        sortable: false,
                        filterable: false,
                        /* filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Origin", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'Invoice No',
                        field: 'invoiceid',
                        sortable: false,
                        filterable: false,
                        /* filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Invoice No", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'Ref Other',
                        field: 'refother',
                        sortable: false,
                        filterable: false,
                        /* filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Ref Other", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'Invoice Date',
                        field: 'invoice_date',
                        sortable: false,
                        filterable: false,
                        /* filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Invoice Date", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'Due Date',
                        field: 'due_date',
                        sortable: false,
                        filterable: false,
                        /* filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Due Date", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'Past Due',
                        field: 'over_due',
                        sortable: false,
                        filterable: false,
                        type: 'number',
                        /* filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Past Due", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'Amount Due',
                        field: 'amtdue',
                        sortable: false,
                        filterable: false,
                        type: 'number',
                        /* filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Amount Due", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'Action',
                        field: 'actions',
                        sortable: false,
                        filterable: false,
                        /* filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Origin", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                            /*{
                             label: 'CusId',
                             field: 'cusid',
                             filterable: true,
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "CusId", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'Customer Name',
                             field: 'first_name',
                             filterable: true,
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "Customer Name", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             filterDropdownItems: [], // dropdown (with selected values) instead of text input
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'Customer Type',
                             field: 'customer_type',
                             filterable: true,
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "Customer Type", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'Past Due',
                             field: 'due_days',
                             filterable: true,
                             type: 'number',
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "Past Due", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'Current Due',
                             field: 'current_due',
                             filterable: true,
                             type: 'number',
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "Current Due", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'D1TO30D',
                             field: 'D1TO30D',
                             filterable: false,
                             type: 'number',
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "Due 1 to 30", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'D31TO60D',
                             field: 'D31TO60D',
                             filterable: false,
                             type: 'number',
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "Due 31 to 60", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'D61TO90D',
                             field: 'D61TO90D',
                             filterable: false,
                             type: 'number',
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "due 61 to 90", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             },
                             {
                             label: 'Total Due',
                             field: 'total_due',
                             filterable: true,
                             type: 'number',
                             filterOptions: {
                             enabled: false, // enable filter for this column
                             placeholder: "Total Due", // placeholder for filter input
                             filterValue: '', // initial populated value for this filter
                             trigger: "enter" //only trigger on enter not on keyup
                             }
                             }*/
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                    page: 1,
                    perPage: 10,
                    setCurrentPage: 1,
                },
                selectedRows: 0,
                collectorArr: [],
                entityArr: [],
                collectorId: "",
                collectorIdSearch: "",
                entityIdSearch: "",
                customer_id: "",
                customerArr: [],
                status_id: {
                    text: "Active",
                    value: "active"
                },
                statusArr: [
                    {
                        text: 'All',
                        value: 'all',
                    },
                    {
                        text: 'Active',
                        value: 'active',
                    },
                    {
                        text: 'Inactive',
                        value: 'inactive',
                    },
                ],

            }),

        mounted: function () {
            var self = this;
            $(".removeActive").removeClass('active');
            $("#menudunningnotice").addClass('active');
            self.jumpToPage = self.serverParams.page;
            self.pageCompare = Math.ceil(self.displayPage / 2);
            $("#jumpToPage").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPage(self.jumpToPage)
                }
            });
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            self.showLoader();
            $("#totlaDueCondition").change(function () {
                self.totalDueCondition = $("#totlaDueCondition").val();
            });
            // self.loadCustomers();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            // self.loadCollector();
            self.loadEntity();
            self.loadCustomerName();
            /*$('.datetimepicker').bootstrapMaterialDatePicker({
             // format: 'dddd DD MMMM YYYY - HH:mm',
             format: 'MM/DD/YYYY HH:mm:ss',
             clearButton: true,
             weekStart: 1
             });*/
        },
        beforeMount: function () {

            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        methods: {
            /*customPageChange(customCurrentPage) {
             },
             customPerPageChange() {
             },*/
            selectAllCallback: function(event) {
                // console.log(event.selected);
                if(event.selected) {
                    $('.pointer-events').prop('checked', true);
                } else {
                    $('.pointer-events').prop('checked', false);
                }
            },
            onSearchCustomerName(search) {
                if (search.length > 2) {
                    this.loadCustomerName(search, this);
                }
            },
            loadCustomerName(search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/customer/search",
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.customerArr = data;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                })
            },
            changedValue: function (value) {
                /*console.log(value);*/
            },
            customerWiseSelected: function (customerRow, selectButtonTitle, isAllRowSelected, event) {
                var self = this;
                isAllRowSelected = (isAllRowSelected === null || typeof (isAllRowSelected) === "undefined" || isAllRowSelected == '' || isAllRowSelected == 0) ? false : isAllRowSelected;
                if(isAllRowSelected) {
                    for (var j = 0; j < customerRow.length; j++) {
                        for (var i = 0; i < customerRow[j]['children'].length; i++) {
                            /* if (selectButtonTitle == 'select-all') {
                                this.$set(customerRow[j]['children'][i], 'vgtSelected', true);
                            } else { 
                                this.$set(customerRow[j]['children'][i], 'vgtSelected', false);
                            } */
                            if (!customerRow[j]['children'][i].vgtSelected) {
                                this.$set(customerRow[j]['children'][i], 'vgtSelected', true);
                            } else {
                                this.$set(customerRow[j]['children'][i], 'vgtSelected', false);
                            }
                        }
                    }
                } else {
                    // console.log(event.target.checked);
                    if(customerRow['children'] && customerRow['children'].length > 0) {
                        for (var i = 0; i < customerRow['children'].length; i++) {
                            /* if (selectButtonTitle == 'select-all') {
                                this.$set(customerRow['children'][i], 'vgtSelected', true);
                            } else { 
                                this.$set(customerRow['children'][i], 'vgtSelected', false);
                            } */
                            if (event.target.checked) {
                            // if (!self.selectAllInvoice) {
                                this.$set(customerRow['children'][i], 'vgtSelected', true);
                            } else {
                                this.$set(customerRow['children'][i], 'vgtSelected', false);
                            }
                        }
                    }
                }
            },
            jumpToInputPage: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberList()) {
                    pageNumber = self.pageNumberList();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPage).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClick(pageNumber);
            },
            onPerticularPageClick: function (pageNumber) {
                var self = this;
                self.serverParams.page = pageNumber;
                self.jumpToPage = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoad != 1 && self.jumpToPage != 1) {
                    self.loadCustomers();
                } else if(self.firstLoad == 1 && self.jumpToPage >=1) {
                    self.loadCustomers();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberList: function () {
                var self = this;
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            changedValueCustomPerPage: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoad == 1) {
                    self.jumpToInputPage(self.serverParams.page);
                    self.loadCustomers();
                }
                /* Single Backend Call on page load end */
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_dunning_notice_list') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },

            changedValue: function (value) {
                var self = this;
                console.log(value);
                self.loadCollector();
                self.loadEntity();
            },

            inactiveDunningNotice: function (cusData) {
                var self = this;
                var segments = cusData.id;
                var current_status = cusData.children[0].overdue_status;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/update/customer/" + segments,
                    type: "POST",
                    data: {custId: segments, status: current_status},
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.code == '200') {
                            Swal.fire({
                                type: 'success',
                                title: 'Success',
                                html: data.message,
                            });
                        }
                        self.loadCustomers();
                    },
                    error: function (jqXHR, exception) {
                        self.loadCustomers();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadEntity() {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/getEntity",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: "json",
                    success: function (data) {
                        self.entityArr = data.content;
                        // console.log(self.entityArr);
                        if (data.content.length > 1) {
                            // self.entityArr.splice(0, 0, "All"); 

                            // Uncomment below to have 'All' selected by default
                            // self.entityIdSearch = {text: "All", value: 0};
                            self.entityIdSearch = {text: data.content[1].text, value: data.content[1].value};
                            
                        } else if (data.content.length == 1) {
                            self.entityIdSearch = {text: data.content[0].text, value: data.content[0].value};
                        }
                        self.$nextTick(function () {
                            self.loadCustomers();
                        });
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },

            loadCollector() {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/getCollector",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: "json",
                    success: function (data) {
                        self.collectorArr = data.content;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },

            sendMailALL: function (e)
            {
                var self = this;
                var collectId = "";
                if (self.collectorIdSearch === null || self.collectorIdSearch == '') {
                    collectId = "";
                } else {
                    collectId = self.collectorIdSearch.value;
                }
                var entityId = "";
                if (self.entityIdSearch === null || self.entityIdSearch == '') {
                    entityId = "";
                } else {
                    entityId = self.entityIdSearch.value;
                }
                self.flagAll = 'flagAll_Dunning';
                var scheduleDate = '';
                if (this.checked) {
                    scheduleDate = $('#scheduleDateAll').val();
                }
                var duningTemplateAll = $('#duningTemplateAll').val();
                //change button
                $(e.target).text('Sending...');
                $(e.target).prop("disabled", true);

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    flag: "welcomeCustomers",
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    totlaDueCondition: self.totalDueCondition,
                    totalDue1: $('#totalDueAmt1').val(),
                    totalDue2: $('#totalDueAmt2').val(),
                    flagValue: self.flagAll,
                    scheduleDate: scheduleDate,
                    duningTemplateSelected: self.duningTemplateSelected,
                    duningTemplateAll: self.duningTemplateAll,
                    /*collectorid: $("#collectorFilter").val(),*/
                    collectorid: collectId,
                    entityid: entityId,
                };

                this.firstLoad = 1;
                // console.log(self.serverParams.perPage);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/listdunningnotice",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.loadCustomers();
                        $(e.target).text('Send to All');
                        $(e.target).prop("disabled", false);
                        self.rows = data.content.row;
                        $('#scheduleDateAll').val('');
                        $('#queueEmailAll').modal('hide');
                        if (data.code == '200') {
                            // self.rows = data.content.row;
                            // self.totalRecords = data.content.totalRecords;
                            self.flagAll = '';

                            //alert("ALL Mail Scheduled Successfully.");
                            Swal.fire({
                                type: 'success',
                                title: 'Success',
                                html: 'ALL Mail Scheduled Successfully.',
                                showConfirmButton: true,
                            });
                        }
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        self.loadCustomers();
                        $(e.target).text('Send to All');
                        $(e.target).prop("disabled", false);
                        $('#scheduleDateAll').val('');
                        $('#queueEmailAll').modal('hide');
                        self.rows = data.content.row;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });
            },

            sendMail: function (e) {

                var selectedCustomers = this.$refs['listDunningNotice'].selectedRows;
                var invoiceArr = [];
                for (var i = 0; i < selectedCustomers.length; i++) {
                    invoiceArr.push(this.$refs['listDunningNotice'].selectedRows[i].id);
                }
                var scheduleDate = '';
                if (this.checked) {
                    scheduleDate = $('#scheduleDate').val();
                }
                var duningTemplateSelected = $('#duningTemplateSelected').val();
                //console.log(duningTemplateSelected);
                //change button 
                $(e.target).text('Sending...');
                $(e.target).prop("disabled", true);
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/customer/send_dunning_notice",
                    type: "POST",
                    data: {
                        invoiceArr: invoiceArr,
                        scheduleDate: scheduleDate,
                        duningTemplateSelected: duningTemplateSelected,
                        totlaDueCondition: self.totalDueCondition,
                        totalDue1: $('#totalDueAmt1').val(),
                        totalDue2: $('#totalDueAmt2').val(),
                    },
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        //send mail button
                        $(e.target).text('Send to Selected');
                        $(e.target).prop("disabled", false);
                        self.loadCustomers();
                        self.checked = false;
                        $('#scheduleDate').val('');
                        $('#queueEmail').modal('hide');
                        if (data.code == '200') {
                            //alert("Mail Scheduled Successfully.");
                            Swal.fire({
                                type: 'success',
                                title: 'Success',
                                html: 'Mail Scheduled Successfully.',
                                showConfirmButton: true,
                            });
                        }
                    },
                    error: function (jqXHR, exception) {
                        $('#scheduleDate').val('');
                        $('#queueEmail').modal('hide');
                        $(e.target).text('Send to Selected');
                        $(e.target).prop("disabled", false);
                        self.loadCustomers();
                        self.checked = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },

            scheduleDunningNotices: function (e, isSelected) {
                var self = this;
                var selectdDunningNoticeArr = [];
                if(isSelected) {
                    var selectedDunningNotices = this.$refs["listDunningNotice"].selectedRows;
                    for (var i = 0; i < selectedDunningNotices.length; i++) {
                        selectdDunningNoticeArr.push(selectedDunningNotices[i].id);
                    }
                }/*  else {
                    if(self.rows.length > 0) {
                        for (var i = 0; i < self.rows.length; i++) {
                            var obj = self.rows[i];
                            for (var j = 0; j < obj['children'].length; j++) {
                                selectdDunningNoticeArr.push(obj['children'][j]['id']);
                            }
                        }
                    }
                } */
                console.log(selectdDunningNoticeArr);// return;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/dunningnotice/schedule",
                    type: "POST",
                    data: {
                        entityid: (self.entityIdSearch == null || !self.entityIdSearch.value) ? 8 : self.entityIdSearch.value,
                        selected_invoice: isSelected,
                        dunning_invoices: selectdDunningNoticeArr
                    },
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        //send mail button
                        // self.loadCustomers();
                        self.loadEntity();
                        self.checked = false;
                        $('#scheduleDate').val('');
                        if (data.code == '200') {
                            //alert("Mail Scheduled Successfully.");
                            Swal.fire({
                                type: 'success',
                                title: 'Success',
                                html: 'Mail Scheduled Successfully.',
                                showConfirmButton: true,
                            });
                        }
                    },
                    error: function (jqXHR, exception) {
                        $('#scheduleDate').val('');
                        $('#queueEmail').modal('hide');
                        // $(e.target).text('Send to Selected');
                        // $(e.target).prop("disabled", false);
                        self.loadEntity();
                        // self.loadCustomers();
                        self.checked = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            //
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                console.log("onPageChange......");
                this.loadCustomers();
            },
            //
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                console.log("onPerPageChange......");
                this.loadCustomers();
            },

            onColumnFilter(params)
            {
                this.updateParams(params);
                {
                    field: ('first_name');
                    field: ('description');
                    field: ('cusid');
                    field:('customer_type');
                    field:('created_at');
                    field: ('contact_name');
                    field: ('contact_phone');
                    field: ('email');
                    field:('collector');
                    field:('amount_balance');
                    field: ('total_due');
                    field: ('D61TO90D');
                    field: ('D31TO60D');
                    field:('D1TO30D');
                    field:('current_due');
                    field: ('paid_amount');
                    field: ('invoice_amount');
                    field:('cusid');
                    field:('invoice_date');
                }
                this.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.first_name || filters.description || filters.cusid || filters.customer_type
                        || filters.created_at || filters.contact_name || filters.contact_phone || filters.email || filters.collector
                        || filters.amount_balance || filters.total_due || filters.D61TO90D || filters.D31TO60D || filters.D1TO30D
                        || filters.current_due || filters.paid_amount || filters.invoice_amount || filters.invoice_date
                        || filters.cusid) {
                    this.loadCustomers();
                }
            },
            selectionChanged() {
                var self = this;
                self.selectedRows = (self.$refs['listDunningNotice'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            allClickDunning: function () {
                var self = this;
                self.message = 'all';
                self.loadCustomers();
            },
            myClickDunning: function () {
                var self = this;
                self.message = 'my';
                self.serverParams.page = 1;
                self.jumpToPage = 1;
                self.loadCustomers();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        /* type: params.sortType,
                        field: this.columns[params.columnIndex].field, */
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadCustomers();
            },

            reset: function () {
                var self = this;
                self.totalDueCondition = '';
                $('#totlaDueCondition').val('');
                $('#totalDueAmt1').val('');
                $('#totalDueAmt2').val('');
                $("#collectorFilter").val('');
                self.collectorIdSearch = '';
                self.entityIdSearch = '';
                self.customer_id = '';
                self.status_id = {
                    text: "Active",
                    value: "active"
                }
                // self.loadCustomers();
                self.loadEntity();
            },
            loadCustomers: function () {
                var self = this;
                this.rowCheckShow = false;
                self.serverParams.setCurrentPage = self.serverParams.page;
                if (self.message == 'my') {
                    self.toggleButtons(self.message, 'btn_my_dunning', 'btn_all_dunning');
                } else {
                    self.toggleButtons(self.message, 'btn_all_dunning', 'btn_my_dunning');
                }
                var collectId = "";
                if (self.collectorIdSearch === null || self.collectorIdSearch == '') {
                    collectId = "";
                } else {
                    collectId = self.collectorIdSearch.value;
                }
                var entityId = "";
                if (self.entityIdSearch === null || self.entityIdSearch == '') {
                    entityId = "";
                } else {
                    entityId = self.entityIdSearch.value;
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    flag: "dunning",
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    totlaDueCondition: self.totalDueCondition,
                    totalDue1: $('#totalDueAmt1').val(),
                    totalDue2: $('#totalDueAmt2').val(),
                    /*collectorid: $("#collectorFilter").val(),*/
                    collectorid: collectId,
                    entityid: entityId,
                    customer_id: self.customer_id.value,
                    status_id: self.status_id.value,
                };

                this.firstLoad = 1;
                // console.log(self.serverParams.perPage);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/listdunningnotice",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.status_value = self.status_id.value;
                        if (data.code == '200') {
                            self.tierNotification = data.content.notification;
                            self.tierNotificationColor = data.content.notification_color;
                            self.isShowQueueEmailButton = data.content.is_show_queue_email_button;
                            self.queueButtonColor = data.content.queue_button_color;
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.showHidePagination("dunningNoticeList", self.totalRecords);
                            self.jumpToPage = self.serverParams.page;

                            self.rowCheckShow = false;
                            if(self.entityIdSearch.value != 0 && self.rows.length > 0) {
                                self.rowCheckShow = true;
                                self.customerWiseSelected(self.rows, 'select-all', true);
                            }
                        }
                        self.paginationDisplayRows = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }

        }
    };
</script>

<style scoped>
    .pointer-events {
        pointer-events: unset !important;
    }
    .vgt-table th.vgt-row-header .triangle {
        margin: 0px 8px 0px -25px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/dunningNotices/ListDunningNotices.vue